<script setup lang="ts">
  import {
    InfoTooltip,
    type TooltipOffset,
    type TooltipPosition,
    type TooltipSizeType,
  } from '@tundr/ds-components';
  import type { TUNDR_ICONS } from '@tundr/theme-assets/tundr-icons/tundr-icons-icons';
  import { infoTooltipCellClass } from './InfoTooltipCell.css.ts';

  withDefaults(
    defineProps<{
      title?: string;
      description?: string;
      showTooltip?: boolean;
      iconName?: TUNDR_ICONS;
      position?: TooltipPosition;
      size?: TooltipSizeType;
      offset?: TooltipOffset;
      ariaLabel?: string;
      triggerClass?: string;
      testId?: string;
    }>(),
    {
      showTooltip: true,
    },
  );
</script>

<template>
  <span :class="infoTooltipCellClass">
    <slot />
    <InfoTooltip
      v-if="showTooltip"
      :title="title"
      :description="description"
      :icon-name="iconName"
      :position="position"
      :size="size"
      :offset="offset"
      :aria-label="ariaLabel"
      :trigger-class="triggerClass"
      :test-id="testId"
    />
  </span>
</template>
